export const translations = {
  it: {
    nav: {
      grid: "La Griglia",
      manifesto: "Manifesto",
      dashboard: "I miei pixel",
      login: "Accedi",
      logout: "Esci",
      buy: "Riserva il tuo pixel",
    },
    hero: {
      eyebrow: "500.000 VOLTI · UN SOLO RITRATTO · 1 DOLLARO",
      line1: "HUMANITY",
      line2: "MOSAIC",
      tagline: "La Pagina dell'Umanità",
      sub: "Un dollaro. Un pixel. Il tuo volto. A gennaio 2027, 500.000 ritratti di persone da tutto il mondo formeranno il volto di Gandhi: il più grande mosaico umano mai creato.",
      ctaBuy: "Riserva il tuo pixel — $1",
      ctaGrid: "Esplora la griglia",
      scroll: "SCORRI",
    },
    stats: {
      sold: "Pixel venduti",
      remaining: "Pixel rimanenti",
    },
    ticker: {
      label: "ULTIMI PIXEL",
      empty: "IL PRIMO PIXEL DELLA STORIA È ANCORA LIBERO — SARÀ IL TUO?",
    },
    manifesto: {
      eyebrow: "IL MANIFESTO",
      title: "Tre atti verso\nun unico volto",
      ch1t: "Il Pixel",
      ch1: "Ogni pixel costa un dollaro. Non di più, non di meno. Ogni quadratino è un pezzo di storia digitale — ma qui nessun pixel è pubblicità. Ogni pixel è una persona.",
      ch2t: "Il Volto",
      ch2: "Con il tuo pixel carichi il ritratto del tuo volto: frontale, centrato, 400×400 pixel. Il sistema lo ritaglia automaticamente nella misura esatta. Nessun filtro, nessuna posa: solo il tuo volto, come sei.",
      ch3t: "Il Ritratto",
      ch3: "Potrai assistere alla composizione del volto via via che i volti vengono caricati.",
    },
    gandhi: {
      eyebrow: "GENNAIO 2027",
      title: "500.000 volti.\nUno solo: il suo.",
      body: "Mohandas Karamchand Gandhi trasformò milioni di singole persone in un unico movimento, senza violenza. Questa pagina fa il percorso inverso: un unico ritratto, composto da centinaia di migliaia di individui. Ogni volto conta. Ogni volto è visibile. Ogni volto è necessario.",
    },
    countdown: {
      label: "ALLA RIVELAZIONE · GENNAIO 2027",
      days: "GIORNI",
      hours: "ORE",
      minutes: "MINUTI",
      seconds: "SECONDI",
    },
    grid: {
      title: "La Griglia",
      sub: "500.000 pixel sul volto di Gandhi · $1 ciascuno",
      available: "LIBERO",
      sold: "VENDUTO",
      yours: "TUO",
      clickToBuy: "Clicca un pixel libero per riservarlo",
      zoom: "Zoom: rotella del mouse · Trascina per esplorare",
      buyAny: "Riserva un pixel",
      loading: "Caricamento della griglia…",
      owner: "Proprietario",
      anonymous: "Anonimo",
      hasPhoto: "Foto caricata",
      noPhoto: "Foto mancante",
      coords: "COORDINATE",
      status: "STATO",
    },
    auth: {
      loginTitle: "Bentornato",
      registerTitle: "Entra nella pagina",
      name: "Nome e cognome",
      email: "Email",
      password: "Password",
      loginBtn: "Accedi",
      registerBtn: "Crea il tuo account",
      loginTab: "Accedi",
      registerTab: "Registrati",
      success: "Accesso effettuato",
      registered: "Account creato. Benvenuto nella pagina dell'umanità.",
    },
    checkout: {
      title: "Riserva il tuo pixel",
      pixel: "Pixel",
      quantity: "Quantità",
      total: "Totale",
      payDemo: "Paga in modalità demo",
      payPaypal: "Paga con PayPal",
      demoNote: "Modalità demo attiva: nessun addebito reale. I pagamenti PayPal saranno attivati a breve.",
      success: "Pixel riservato! Ora carica la foto del tuo volto.",
      processing: "Elaborazione…",
      priceNote: "1 pixel = $1 · il tuo posto nella storia",
    },
    upload: {
      title: "Il tuo volto",
      choose: "Scegli una foto",
      specs: "Requisiti: foto frontale, volto centrato e ben illuminato. Il ritaglio è quadrato 1:1 — verrà salvata in 400×400 px.",
      save: "Salva il volto",
      cancel: "Annulla",
      success: "Volto caricato. Fai parte del ritratto.",
      zoom: "Zoom",
    },
    dash: {
      title: "I tuoi pixel",
      subtitle: "La tua posizione nella pagina dell'umanità",
      empty: "Non hai ancora nessun pixel. Il tuo posto nella storia ti aspetta.",
      buyFirst: "Riserva il tuo primo pixel",
      addPhoto: "Carica il volto",
      changePhoto: "Cambia foto",
      photoOk: "Volto presente",
      pixelLabel: "PIXEL",
      welcome: "Bentornato,",
    },
    footer: {
      tagline: "La pagina dell'umanità · The Page of Humanity",
      rights: "Un dollaro. Un pixel. Un volto. Per sempre.",
    },
    common: {
      loading: "Caricamento…",
      error: "Qualcosa è andato storto. Riprova.",
    },
  },
  en: {
    nav: {
      grid: "The Grid",
      manifesto: "Manifesto",
      dashboard: "My pixels",
      login: "Sign in",
      logout: "Sign out",
      buy: "Claim your pixel",
    },
    hero: {
      eyebrow: "500,000 FACES · ONE PORTRAIT · 1 DOLLAR",
      line1: "HUMANITY",
      line2: "MOSAIC",
      tagline: "The Page of Humanity",
      sub: "One dollar. One pixel. Your face. In January 2027, 500,000 portraits from all over the world will merge into the face of Gandhi: the largest human mosaic ever created.",
      ctaBuy: "Claim your pixel — $1",
      ctaGrid: "Explore the grid",
      scroll: "SCROLL",
    },
    stats: {
      sold: "Pixels sold",
      remaining: "Pixels remaining",
    },
    ticker: {
      label: "LATEST PIXELS",
      empty: "THE FIRST PIXEL IN HISTORY IS STILL FREE — WILL IT BE YOURS?",
    },
    manifesto: {
      eyebrow: "THE MANIFESTO",
      title: "Three acts toward\na single face",
      ch1t: "The Pixel",
      ch1: "Each pixel costs one dollar. No more, no less. Every square is a piece of digital history — but here no pixel is advertising. Every pixel is a person.",
      ch2t: "The Face",
      ch2: "With your pixel you upload a portrait of your face: front-facing, centered, 400×400 pixels. The system automatically crops it to the exact size. No filters, no poses: just your face, as you are.",
      ch3t: "The Portrait",
      ch3: "You will watch the face being composed, as the faces are uploaded one by one.",
    },
    gandhi: {
      eyebrow: "JANUARY 2027",
      title: "500,000 faces.\nOnly one: his.",
      body: "Mohandas Karamchand Gandhi turned millions of individuals into a single movement, without violence. This page walks the path in reverse: a single portrait, composed of hundreds of thousands of individuals. Every face matters. Every face is visible. Every face is needed.",
    },
    countdown: {
      label: "UNTIL THE REVEAL · JANUARY 2027",
      days: "DAYS",
      hours: "HOURS",
      minutes: "MINUTES",
      seconds: "SECONDS",
    },
    grid: {
      title: "The Grid",
      sub: "500,000 pixels on Gandhi's face · $1 each",
      available: "FREE",
      sold: "SOLD",
      yours: "YOURS",
      clickToBuy: "Click a free pixel to claim it",
      zoom: "Zoom: mouse wheel · Drag to explore",
      buyAny: "Claim a pixel",
      loading: "Loading the grid…",
      owner: "Owner",
      anonymous: "Anonymous",
      hasPhoto: "Photo uploaded",
      noPhoto: "Photo missing",
      coords: "COORDINATES",
      status: "STATUS",
    },
    auth: {
      loginTitle: "Welcome back",
      registerTitle: "Join the page",
      name: "Full name",
      email: "Email",
      password: "Password",
      loginBtn: "Sign in",
      registerBtn: "Create your account",
      loginTab: "Sign in",
      registerTab: "Register",
      success: "Signed in",
      registered: "Account created. Welcome to the page of humanity.",
    },
    checkout: {
      title: "Claim your pixel",
      pixel: "Pixel",
      quantity: "Quantity",
      total: "Total",
      payDemo: "Pay in demo mode",
      payPaypal: "Pay with PayPal",
      demoNote: "Demo mode active: no real charge. PayPal payments will be enabled soon.",
      success: "Pixel reserved! Now upload your face photo.",
      processing: "Processing…",
      priceNote: "1 pixel = $1 · your place in history",
    },
    upload: {
      title: "Your face",
      choose: "Choose a photo",
      specs: "Requirements: front-facing photo, centered and well lit. The crop is 1:1 square — it will be saved at 400×400 px.",
      save: "Save your face",
      cancel: "Cancel",
      success: "Face uploaded. You are part of the portrait.",
      zoom: "Zoom",
    },
    dash: {
      title: "Your pixels",
      subtitle: "Your place on the page of humanity",
      empty: "You don't own any pixels yet. Your place in history awaits.",
      buyFirst: "Claim your first pixel",
      addPhoto: "Upload face",
      changePhoto: "Change photo",
      photoOk: "Face present",
      pixelLabel: "PIXEL",
      welcome: "Welcome back,",
    },
    footer: {
      tagline: "The Page of Humanity · La pagina dell'umanità",
      rights: "One dollar. One pixel. One face. Forever.",
    },
    common: {
      loading: "Loading…",
      error: "Something went wrong. Please try again.",
    },
  },
};

import { extra } from "./i18n_extra";
for (const lang of ["it", "en"]) {
  for (const [k, v] of Object.entries(extra[lang])) {
    translations[lang][k] = { ...(translations[lang][k] || {}), ...v };
  }
}
